import { render, staticRenderFns } from "./alignTop_off.vue?vue&type=template&id=2f689ec5&"
import script from "./alignTop_off.vue?vue&type=script&lang=ts&"
export * from "./alignTop_off.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports